// material-ui
import { Typography, Button, Stack, Input, Alert, Table, TableBody, TableCell, TableRow, TableHead, Select, MenuItem, FormHelperText, Grid, Paper, Divider } from '@mui/material';
import { Box } from '@mui/system';
import Pagination from 'components/@extended/Pagination';
import Image from 'components/Image';

// project import
import MainCard from 'components/MainCard';
import MapRoute from 'components/MapRoute';
import React from 'react';
import { useParams } from 'react-router';
import { getRequest } from 'utils/apiRequest';


// ==============================|| SAMPLE PAGE ||============================== //
const _MS_PER_DAY = 1000 * 60 * 60 * 24;

// a and b are javascript Date objects
function dateDiffInDays(a, b) {
    if(a === null || b === null || isNaN(a) || isNaN(b) || a.getYear() < 2020 || b.getYear() < 2020) return 0;
    var seconds = (b.getTime() - a.getTime()) / 1000;
    var days = Math.floor(seconds / 3600)
    console.log(a, b, days);
    return days;
}

const Address = (props) => {
    const { address } = props;
    return (
        <address>
            {address.line_1}{(address.line_2 !== null || address.line_3 !== null ? null : <br />)}
            {address.line_2 ? (<>,&nbsp;{address.line_2}<br /></>) : null}
            {address.line_3 ? (<>,&nbsp;{address.line_3}<br /></>) : null}
            {address.city}{address.state ? ', ' + address.state : ''} {address.zip}
        </address>)
}

const Widget = ({ title, children }) => {
    return (
        <Box>
            <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
            {children}
        </Box>)
}

const TABLE_NAME_STYLE = {
    fontWeight: 'bold',
    width: 140
}

const TransitLog = () => {
    const { trackingNumber } = useParams();
    const [details, setDetails] = React.useState({});
    const [times, setTimes] = React.useState({ transit: 0, fulfilment: 0, total: 0 });

    React.useEffect(() => {
        getTrackingNumberDetails(trackingNumber);
    }, []);


    const getTrackingNumberDetails = (tn) => {
        getRequest('/account/tracking/' + tn).then((d) => {
            setDetails(d);
            // test it
            const a = new Date(d.ordered_at),
                b = new Date(d.shipped_at),
                c = new Date(d.delivered_at);
            setTimes({
                fulfillment: dateDiffInDays(a, b),
                transit: dateDiffInDays(b, c),
                total: dateDiffInDays(a, c),
            })

        })
    }



    return (
        <MainCard title={"Transit: " + trackingNumber}>
            {details.product && (
                <Grid container spacing={3} sx={{mb: 3}}>
                    <Grid item sm={6}>
                        <Grid container spacing={3}>
                            <Grid item sx={{ width: 95 }}>
                                <Image src={details.product.image_url} alt="" width={75} height={75} />
                            </Grid>
                            <Grid item>
                                {details.product.name}<br />
                                {details.product.sku}<br />
                                {details.product.category}<br />
                                {details.product.upc}<br />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={3}>
                        <Widget title="Ship From">
                            <Address address={details.ship_from} />
                        </Widget>
                    </Grid>
                    <Grid item sm={3}>
                        <Widget title="Ship To">
                            <Address address={details.ship_to} />
                        </Widget>
                    </Grid>
                </Grid>
            )}
            <Divider />
            {details.ship_from && (
                <>
                            <Table size="small">
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={TABLE_NAME_STYLE}>Warehouse</TableCell>
                                        <TableCell>{details.warehouse?.name}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Total Time</TableCell>
                                        <TableCell>{times.total + (times.total === 1 ? ' day' : ' days')}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Ordered At</TableCell>
                                        <TableCell>{details.ordered_at ?? '--'}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={TABLE_NAME_STYLE}>Order Number</TableCell>
                                        <TableCell>{details.order_number}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Fulfillment Time</TableCell>
                                        <TableCell>{times.fulfillment + (times.fulfillment === 1 ? ' day' : ' days')}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Shipped At</TableCell>
                                        <TableCell>{details.shipped_at ?? '--'}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={TABLE_NAME_STYLE}>Carrier</TableCell>
                                        <TableCell>{details.carrier?.name}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Transit Time</TableCell>
                                        <TableCell>{times.transit + (times.transit === 1 ? ' day' : ' days')}</TableCell>
                                        <TableCell sx={TABLE_NAME_STYLE}>Delivered At</TableCell>
                                        <TableCell>{details.delivered_at ?? '--'}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                </>
            )}
            {details.ship_from !== undefined && (<>
            <Box sx={{
                display: 'grid', 
                gridTemplateColumns: '1fr 1fr', 
                gap: 1,
                mt: 1,
                p: 1,
                background: '#fafafb',
                border: '1px solid #e6ebf1',
                borderBottom: 0
            }}>
                <div><strong>Ship From:</strong> {details.ship_from?.city + ', ' + details.ship_from?.state + ' ' + details.ship_from?.zip}</div>
                <div><strong>Ship To:</strong> {details.ship_to?.city + ', ' + details.ship_to?.state + ' ' + details.ship_to?.zip}</div>
            </Box>
            <MapRoute from={details.ship_from} to={details.ship_to} />
            </>
            )}
            {/* <pre>
                {JSON.stringify(details, null, 2)}
            </pre> */}
        </MainCard>);
}

export default TransitLog;
